import { SetEngagementNotificationSettingInput } from 'api/graphql-global-types';

export type FormValues = Required<{
  [Key in keyof SetEngagementNotificationSettingInput]: number;
}>;

const WAIT_FIELDS: (keyof FormValues)[] = [
  'firstWindowMinutes',
  'secondWindowMinutes',
  'thirdWindowMinutes',
  'busyWindowMinutes',
];

export const formatMinutes = (minutes: number): string => {
  if (minutes < 60) return `${minutes} min`;
  const hours = minutes / 60;
  return Number.isInteger(hours) ? `${hours} h` : `${hours.toFixed(1)} h`;
};

/** "2 min → 15 min → 1 h → then every 4 h", from whatever is typed in. */
export const describeWaits = (values: Partial<FormValues>): string | null => {
  const waits = WAIT_FIELDS.map((field) => values[field]);
  if (waits.some((minutes) => !minutes)) return null;
  const [first, second, third, busy] = waits as number[];
  return `${formatMinutes(first)} → ${formatMinutes(second)} → ${formatMinutes(
    third
  )} → then every ${formatMinutes(busy)}`;
};

/** A wait may not be shorter than the one before it, as the backend requires. */
type WaitRule = (form: { getFieldValue: (name: string) => number }) => {
  validator: (rule: unknown, value?: number | null) => Promise<void>;
};

export const notShorterThan =
  (previous: keyof FormValues): WaitRule =>
  ({ getFieldValue }) => ({
    validator: (_, value) =>
      value === undefined || value === null || value >= getFieldValue(previous)
        ? Promise.resolve()
        : Promise.reject(
            new Error('Must be at least as long as the wait before it.')
          ),
  });
